module.exports = __webpack_public_path__ + "img/bu2.3f21bb78.png";